import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DashboardSettings } from '../../models/college-dashboard.model';
import { CollegeDashboardService } from '../../services/college-dashboard.service';
import { CustomSelectComponent } from '../../components/shared/custom-select/custom-select.component';
import { buildYearDropdownOptions } from '../../utils/academic-year.util';

@Component({
  selector: 'app-college-settings',
  standalone: true,
  imports: [CommonModule, FormsModule, CustomSelectComponent],
  templateUrl: './college-settings.component.html',
  styleUrl: './college-settings.component.scss'
})
export class CollegeSettingsComponent implements OnInit {
  settings!: DashboardSettings;

  // Same real year_of_passing values the header's dropdown uses (fetched
  // once by the parent layout, passed down here too) — this "default
  // academic year" feeds the exact same shared academicYear setting the
  // header/Overview/Students read, so it must offer the same option format
  // (plain years, e.g. "2026"), not an unrelated hardcoded list.
  @Input() availableYears: number[] = [];
  deptOptions: string[] = ['All Departments', 'CSE', 'IT', 'ECE', 'EEE'];

  localYear: string = 'All Years';
  localDept: string = 'All Departments';
  localWeekly: boolean = true;
  localAlerts: boolean = true;
  localPractice: boolean = false;

  get yearOptions(): string[] {
    return buildYearDropdownOptions(this.availableYears);
  }

  constructor(private dashboardService: CollegeDashboardService) {}

  ngOnInit(): void {
    this.settings = this.dashboardService.getSettings();
    this.localYear = this.settings.academicYear;
    this.localDept = this.settings.department;
    this.localWeekly = this.settings.weeklyEmails;
    this.localAlerts = this.settings.opportunityAlerts;
    this.localPractice = this.settings.practiceCredits;
  }

  saveChanges(): void {
    this.dashboardService.saveSettings({
      academicYear: this.localYear,
      department: this.localDept,
      weeklyEmails: this.localWeekly,
      opportunityAlerts: this.localAlerts,
      practiceCredits: this.localPractice
    });
  }
}
